import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getTenants = (token, search, page) => {
    return fetch(`${apiUrl}tenants?search=${search}&page=${page}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default getTenants